import { render, staticRenderFns } from "./CannotGrab.vue?vue&type=template&id=411fd0d3&scoped=true"
import script from "./CannotGrab.vue?vue&type=script&lang=js"
export * from "./CannotGrab.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "411fd0d3",
  null
  
)

export default component.exports